import React from 'react'
const IconReportSearch = ({direction='down'}) => {
  let directionStyle = (direction === 'up') ? { transform: 'rotate(180deg)' } : {}

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style={directionStyle}>
      <path d="M9.99996 17.5833L4.77246 12.3558L5.5385 11.5897L9.45829 15.5176V2.40869H10.5416V15.5095L14.4614 11.5897L15.2275 12.3558L9.99996 17.5833Z" fill="#686867"/>
    </svg>
  )
}

export default IconReportSearch
